import React from 'react';
import { format, isSameDay } from 'date-fns';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';

import { DisplayTimes } from '../../..';
import { getRangeDateFromToday } from '../../../../../utils/dates';
import { ScheduleItemProps } from '../../../../../models/Schedule';
import { fetchSlotsTeleorientation } from '../../../../../modules/slots';

type useTeleorientationSlotsProps = {
  setDisplayDatesPicker: (value: React.SetStateAction<Date[] | undefined>) => void;
  schedule: ScheduleItemProps | undefined;
  setLoading: (value: boolean) => void;
  addSlotTimes: (scheduleSlots: DisplayTimes[]) => void;
  handleGoBack: () => void;
  setDisplayDates: (value: Date[]) => void;
};

export default function useTeleorientationSlots({
  schedule,
  setDisplayDates,
  setDisplayDatesPicker,
  setLoading,
  addSlotTimes,
  handleGoBack
}: useTeleorientationSlotsProps) {
  const [productAllSlots, setProductAllSlots] = React.useState<DisplayTimes[]>();

  const getSlotsTeleorientation = async () => {
    setLoading(true);
    const rangeDates = getRangeDateFromToday(15);
    const result = await fetchSlotsTeleorientation({
      startDate: format(rangeDates.today, 'yyyy-MM-dd'),
      endDate: format(rangeDates.endDate, 'yyyy-MM-dd'),
      specialtyId: 0
    });
    const { data, error } = result;
    if (error) {
      toast.error('Não foi possível consultar agenda no momento.');
      handleGoBack();
    }
    if (!error) {
      if (!data.length) {
        toast.error('Sem agenda disponível no momento.');
        handleGoBack();
      }
      if (data.length) {
        const datesToShow = [] as Date[];
        const teleorientationDates = data.map(item => {
          datesToShow.push(new Date(item.date));
          return {
            id: '',
            time: new Date(item.date),
            slots: item.slots
          };
        });
        setProductAllSlots(teleorientationDates);
        setDisplayDates(datesToShow);
        const [firstDate] = datesToShow;
        onSelectDateTeleorientation(firstDate, teleorientationDates);
        setDisplayDatesPicker(datesToShow);
      }
    }
    setLoading(false);
  };

  const onSelectDateTeleorientation = (date: Date, slots?: DisplayTimes[]) => {
    let productSlotsFiltered;
    if (slots) productSlotsFiltered = slots?.find(item => isSameDay(new Date(item.time), date));
    else productSlotsFiltered = productAllSlots?.find(item => isSameDay(new Date(item.time), date));
    const slotsTimes = [] as DisplayTimes[];
    productSlotsFiltered?.slots.map(item => {
      slotsTimes.push({
        time: new Date(item.hour),
        slots: [item],
        id: uuid()
      });
    });
    addSlotTimes(
      slotsTimes.sort((time, time2) => {
        if (time.time > time2.time) return 1;
        else return -1;
      })
    );
  };

  React.useEffect(() => {
    if (schedule?.channel === 'TELEORIENTATION') {
      getSlotsTeleorientation();
    }
  }, []);

  return { productAllSlots, setProductAllSlots, onSelectDateTeleorientation };
}
